module.exports = __webpack_public_path__ + "img/hourglass-grey24.428c3842.svg";